import moment from "moment";

export default {
  filters: {
    customDate(date) {
      return new Date(date).toDateString();
    },

    parseFormat1(date) { // Last Monday at 3:22PM
      return moment(date).calendar();
    },

    parseFormat2(date) { // March 19, 2020
      return moment(date).format('LL');
    },

    parseFormat3(date) { // 2020/04/30
      return moment(date).format("YYYY/MM/DD");
    }
  }
}